export default __webpack_public_path__ + "static/media/ME_Tagline_logo_Make_Yourself_Comfortable.24651707.png";